module.exports = __webpack_public_path__ + "img/192.3b410fbd.jpg";